import { lazy } from 'react';
var INV00001 = lazy(function () { return import('view/Project/INV/INV00001'); });
var INV00002 = lazy(function () { return import('view/Project/INV/INV00002'); });
var INV_ROUTES = [
    { path: '/INV00/INV00001', component: INV00001 },
    { path: '/INV00/INV00002', component: INV00002 },
];
export default INV_ROUTES;
